module.exports = __webpack_public_path__ + "img/twitter.9499106.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/twitter.svg
// module id = u/Pf
// module chunks = 7